import { ApiOrgProperty } from '@kaiizen/kai-pro-api';
import { kaiPartialIdPresenter } from './idPresenters';

export const propertyIdPresenter = (property?: ApiOrgProperty) =>
  !property
    ? '--'
    : (property?.customerMetadata?.propertyId
      ?? kaiPartialIdPresenter(property.id));
